import React from 'react'

function TeethRoot ({ variant = 'plain', width = 15, color = 'black' }) {
  // Maintaining the 70:310 aspect ratio
  const height = (310 / 70) * width;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 70 310" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block',rotate: '180deg' }}
    >
      {/* The main white triangle (Outer Shell) */}
      <polygon 
        points="5,5 65,5 35,305" 
        fill="white" 
        stroke={color} 
        strokeWidth="10" 
        strokeLinejoin="round" 
      />

      {/* Conditional rendering based on "variant" prop */}
      {/* Root Canal - red filled polygon (also supports old 'filling' value for backward compatibility) */}
      {(variant === 'Root Canal' || variant === 'filling') && (
        <polygon points="30,10 40,10 35,290" fill="red" />
      )}

      {/* Post & Core - red rectangle + path (also supports old 'cavity' value for backward compatibility) */}
      {(variant === 'Post & Core' || variant === 'cavity') && (
        <>
          <rect x="32" y="10" width="6" height="45" fill="red" />
          <path 
            d="M35 55 C33 85, 37 125, 49 135" 
            fill="none" 
            stroke="red" 
            strokeWidth="4" 
            strokeLinecap="round" 
          />
        </>
      )}
    </svg>
  );
}

export default TeethRoot